import { render, staticRenderFns } from "./history-suggestion.vue?vue&type=template&id=07dc6faf&"
import script from "./history-suggestion.vue?vue&type=script&lang=ts&"
export * from "./history-suggestion.vue?vue&type=script&lang=ts&"
import style0 from "./history-suggestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports